import React, { createContext, useContext, useEffect } from 'react'
import { UIStore } from './UIStore'

const UIStoreContext = createContext<UIStore | null>(null)

export const UIStoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const store = React.useMemo(() => new UIStore(), [])

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      // Always call handleMouseMove - it will check internally if we're resizing
      store.handleMouseMove(e)
    }

    const handleMouseUp = () => {
      store.stopResizing()
    }

    // Add listeners once on mount, remove on unmount
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [store])

  return (
    <UIStoreContext.Provider value={store}>
      {children}
    </UIStoreContext.Provider>
  )
}

export const useUIStore = () => {
  const context = useContext(UIStoreContext)
  if (!context) {
    throw new Error('useUIStore must be used within a UIStoreProvider')
  }
  return context
}

